var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "cancel-button",
        {
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("cancel")
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.$t(`${_vm.boletoCancelStep}.cancel`)) + " ")]
      ),
      _c(
        "confirm-button",
        {
          staticClass: "eu-ml_1",
          attrs: { type: "submit", disabled: _vm.disabled },
          on: { click: _vm.handleClick },
        },
        [_vm._v(" " + _vm._s(_vm.$t(`${_vm.boletoCancelStep}.confirm`)) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }